import {
  GRAPHICS_CATEGORY_ID,
  CATEGORY_IDS,
  TEMPLATE_DIFFICULTY_LEVELS,
} from '@/utilities/consts';
import {
  CATEGORY_EDITORIAL_BY_SLUG,
  CATEGORY_VERSION_BY_SLUG,
  FPS_BY_SLUG,
  ORIENTATION_BY_SLUG,
  PEOPLE_BY_SLUG,
  RESOLUTION_BY_SLUG,
} from './category-repo';

export function validateCollectionId({ state, collectionId }) {
  const collection = state.collections[collectionId];
  if (!collection) {
    throw new Error(`invalid collection id: ${collectionId}`);
  }
}

export function isValidCategorySlug({ state, categorySlug }) {
  return !!state.categoryFilters[categorySlug];
}

export function isValidSubCategorySlug({ state, slug }) {
  return !!state.categoryFilters.subCategories[slug];
}

export function validateSlug({ state, slug, category }) {
  const formatCategory = {
    subCategories: 'sub category',
    fileTypes: 'file type',
    themes: 'theme',
    artStyles: 'art style',
  };
  if (!state.categoryFilters[category][slug]) {
    throw new Error(
      `invalid ${formatCategory[category]} slug: ${slug}, for category slug:${state.categoryFilters.slug}`,
    );
  }
}

export function categoryPeopleBySlugOrFail({ state, slug }) {
  if (!state.categoryFilters.id === GRAPHICS_CATEGORY_ID) {
    throw new Error(`category slug: ${state.categoryFilters.slug} does not have people`);
  }
  const peopleOption = PEOPLE_BY_SLUG[slug];
  if (!peopleOption) {
    throw new Error(`people slug: ${slug} is invalid`);
  }
  return peopleOption;
}

export function categoryFpsBySlugOrFail({ state, slug }) {
  if (!state.categoryFilters.hasFps) {
    throw new Error(`category slug: ${state.categoryFilters.slug} does not have fps`);
  }
  const fps = FPS_BY_SLUG[slug];
  if (!fps) {
    throw new Error(`fps slug: ${slug} is invalid`);
  }
  return fps;
}

export function validateCategoryHasResolutions({ state }) {
  if (!state.categoryFilters.hasResolutions && state.categoryFilters.id !== GRAPHICS_CATEGORY_ID) {
    throw new Error(`category slug: ${state.categoryFilters.slug}  does not have resolutions`);
  }
}

export function categoryResolutionBySlugOrFail({ state, slug }) {
  if (!state.categoryFilters.hasResolutions) {
    throw new Error(`category slug: ${state.categoryFilters.slug} does not have resolutions`);
  }
  const resolution = RESOLUTION_BY_SLUG[slug];
  if (!resolution) {
    throw new Error(`resolution slug: ${slug} is invalid`);
  }
  return resolution;
}

export function categoryOrientationBySlugOrFail({ state, slug }) {
  if (!state.categoryFilters.hasResolutions && state.categoryFilters.id !== GRAPHICS_CATEGORY_ID) {
    throw new Error(`category slug: ${state.categoryFilters.slug} does not have orientation`);
  }
  const orientation = ORIENTATION_BY_SLUG[slug];
  if (!orientation) {
    throw new Error(`orientation slug: ${slug} is invalid`);
  }
  return orientation;
}

export function validateCategoryHasVersions({ state }) {
  if (!state.categoryFilters.hasVersions) {
    throw new Error(`category slug: ${state.categoryFilters.slug}  does not have versions`);
  }
}

export function categoryVersionBySlugOrFail({ state, slug }) {
  if (!state.categoryFilters.hasVersions) {
    throw new Error(`category slug: ${state.categoryFilters.slug} does not have versions`);
  }

  const version = CATEGORY_VERSION_BY_SLUG[state.categoryFilters.slug][slug];
  if (!version) {
    throw new Error(
      `version slug: ${slug} is invalid for category slug: ${state.categoryFilters.slug}`,
    );
  }
  return version;
}

export function categoryEditorialBySlugOrFail({ state, slug }) {
  if (!state.categoryFilters.hasEditorials) {
    throw new Error(`category slug: ${state.categoryFilters.slug} does not have editorials`);
  }
  const editorial = CATEGORY_EDITORIAL_BY_SLUG[state.categoryFilters.slug][slug];
  if (!editorial) {
    throw new Error(
      `editorial slug: ${slug} is invalid for category slug: ${state.categoryFilters.slug}`,
    );
  }
  return editorial;
}

export function validateCategoryHasBpms({ state }) {
  if (!state.categoryFilters.hasBpms) {
    throw new Error(`category slug: ${state.categoryFilters.slug}  does not have bpms`);
  }
}

export function validateCategoryHasDurations({ state }) {
  // this looks like a typo but it is how we currently check for duration
  if (!state.categoryFilters.hasBpms) {
    throw new Error(`category slug: ${state.categoryFilters.slug}  does not have duration`);
  }
}

export function validateTemplateDifficultyLevel({ state, templateDifficultyLevle }) {
  const isCategoryEligible = [
    CATEGORY_IDS.AFTER_EFFECTS_TEMPLATES_ID,
    CATEGORY_IDS.PREMIERE_PRO_TEMPLATES_ID,
  ].includes(state.categoryFilters.id);
  const isTemplatesDifficulyLevelEligible =
    !templateDifficultyLevle || templateDifficultyLevle === TEMPLATE_DIFFICULTY_LEVELS.SIMPLE;
  if (!isCategoryEligible && !isTemplatesDifficulyLevelEligible) {
    throw new Error(
      `category slug: ${state.categoryFilters.slug}  is not eligible for ${templateDifficultyLevle} difficulty level.`,
    );
  }
}
